// Core React Imports
import React, { useEffect } from "react";

// Local Imports
import { AlertDialogBackground, DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsImages from "../../../constants/ConstantsImages";
import WidgetIconFive from "../../icons/widget-icon-five/WidgetIconFive";

// CSS/Stylesheets
import "./WidgetAlertDialogSave.css";

const WidgetAlertDialogSave = ({ onCancel, messageText }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onCancel();
    }, 2500);

    // Cleanup the timer if the component unmounts or if isOpen changes
    return () => clearTimeout(timer);
  }, [onCancel]);

  return (
    <AlertDialogBackground>
      <DivColumn className="alert-dialog-overlay-save">
        <WidgetIconFive iconProp={ConstantsImages.APPROVE_IMAGE} widthIconProp="3.1rem" heightIconProp="3.2rem" />
        <DivColumn className="alert-dialog-overlay-2-save">
          <ParagraphText className="alert-dialog-overlay-text-save" style={{ textAlign: "center" }}>
            {messageText}
          </ParagraphText>
        </DivColumn>
      </DivColumn>
    </AlertDialogBackground>
  );
};

export default WidgetAlertDialogSave;
